import { action, computed, observable } from 'mobx';
import { Optional } from 'services/base/types';

export class GenericStore<T> {
  @observable.ref
  value: T;

  constructor(value: T) {
    this.value = value;
  }

  @action.bound
  setValue(value: T) {
    this.value = value;
  }
}

export class BooleanStore extends GenericStore<boolean> {}
export class NumberStore extends GenericStore<number> {}
export class StringStore extends GenericStore<string> {}

export class ChoiceStore<T> {
  @observable.ref
  choices: Record<string, T>;

  @observable.ref
  selected: Optional<string>;

  constructor(choices: Record<string, T>, selected: Optional<string>) {
    this.choices = choices;
    this.selected = selected;
  }

  @action.bound
  setSelected(selected: Optional<string>) {
    const value = selected === undefined ? undefined : this.choices[selected];
    this.selected = value === undefined ? undefined : selected;
  }

  @computed get value(): Optional<T> {
    return this.selected !== undefined ?
           this.choices[this.selected] :
           undefined;
  }
}
